import { Quote } from './Quote';
import { Order } from './Order';
import { Paged } from './Paged';

export interface Subscription {
  id: number;
  creationDate: Date;
  modificationDate?: Date | null;
  orderId: number;
  quote: Quote;
  payorId?: number | null;
  accountNumber?: string | null;
  userName?: string | null;
  password?: string | null;
  comment?: string | null;
  revenue: number | null;
  serviceStartDate?: Date | string | null;
  quoteComments?: string | null;
  collectedRevenue?: number | null;
  actualEarnedRevenue: number | null;
  monthlyPrice?: number | null;
  oneTimeCost?: number | null;
  isCompleted: boolean;
  isCanceled: boolean;
  term?: number | null;
  expirationDate?: Date | null;
  addressVerified: boolean;
  installConfirmed: boolean;
  status: SubscriptionStatus;
  cancelledReasonId?: number | null;
  cancelledAt?: Date | null;
  isRegulated: boolean;
  serviceStartNotes?: string | null;
  order: Order;
  payor: { id: number; name: string };
  contractTerm?: number | null;
  completedAt: Date;
  externalId?: string | null;
  depositCollectedAmount?: number | null;
  depositCollectedDate?: Date | null;
}

export interface AllSubscription extends Subscription {
  service: Quote;
  delta: number;
  collectedRevenue: number;
  order: Order;
}

export interface SubscriptionOptionPayload {
  /** ID of a service-level option. */
  id: number;
  value: string;
}

export enum SubscriptionStatus {
  Pending = 1,
  Completed = 2,
  Cancelled = 3,
}

export interface SubscriptionResult extends Paged<Subscription> {
  totalRevenue?: number;
  totalCollectedRevenue?: number;
}

export interface NEWAllSubscription {
  id: number;
  completedAt: string | null;
  createdDate: string;
  createdEmployeeId: string;
  status: number;
  externalId: string | null;
  duration: number;
  expirationDate: string | null;
  serviceStartDate: string | null;
  collectedRevenue: number;
  internalRevenue: number;
  actualEarnedRevenue: number;
  monthlyPricePayment: number;
  oneTimePayment: number;
  orderId: number;
  orderCreatedDate: string;
  orderCreatedEmployeeId: string;
  salesRepId: string | null;
  salesRepName: string | null;
  orderStageId: number;
  orderStageStatusId: number | null;
  stageName: string;
  licenseeId: number;
  payorId: number | null;
  payorName: string | null;
  serviceId: string;
  servicePrice: number;
  serviceName: string;
  serviceContractTerm: number;
  clientId: number;
  clientName: string;
  clientEmail: string;
  clientPhone: string;
  quoteId: string;
  providerId: string;
  providerName: string;
  depositId: number | null;
  depositAmount: number;
  serviceTypeId: number;
  accountNumber: string | null;
  accountManagerId: string | null;
  accountManagerName: string | null;
  refCompanyId: string | null;
  refCompanyName: string | null;
  cancelledAt: string | null;
  paidDate: string | null;
  chargebackDate: string | null;
}
